import { isTooManyRequestsError } from './errors';

const DEFAULT_COOLDOWN_MS = 90000;

/**
 * Order / sale pages must stay mounted on a 429 so talker Edit booking
 * (`?edit=1`) can open. The full-page busy screen hid the editor.
 *
 * @param {string} [pathname]
 * @returns {boolean}
 */
export const isBookingDetailsPath = pathname =>
  /^\/(order|sale)\/[0-9a-f-]{8,}/i.test(String(pathname || ''));

let markedUntil = 0;

/**
 * True when this tab recently recorded a Sharetribe 429.
 *
 * @returns {boolean}
 */
export const hasRecentRateLimit = () => Date.now() < markedUntil;

/**
 * Remember a Sharetribe 429 so page chrome can show a try-again screen
 * instead of Flex’s fake “app needs to be updated” 404.
 *
 * @param {number} [ms]
 */
export const markClientRateLimited = (ms = DEFAULT_COOLDOWN_MS) => {
  // SSR must not poison later requests on the same Node process.
  if (typeof window === 'undefined') {
    return;
  }
  const wait = Number(ms);
  markedUntil = Date.now() + (Number.isFinite(wait) && wait > 0 ? wait : DEFAULT_COOLDOWN_MS);
};

/**
 * True when this tab recently saw a 429 (or the error itself is one).
 *
 * @param {object} [error]
 * @returns {boolean}
 */
export const shouldShowRateLimitPage = (error, pathname) => {
  const path =
    pathname ||
    (typeof window !== 'undefined' ? window.location?.pathname : '') ||
    '';
  if (isBookingDetailsPath(path)) {
    return false;
  }
  if (isTooManyRequestsError(error)) {
    return true;
  }
  if (!hasRecentRateLimit()) {
    return false;
  }
  // A leftover 429 mark must not replace /sale or checkout with the
  // full-page screen. Only disguised load failures stay on the busy page.
  const message = String(error?.message || error?.statusText || '');
  return /chunk|loading css|too many requests/i.test(message);
};

export const resetClientRateLimit = () => {
  markedUntil = 0;
};
